import { useTranslation } from 'react-i18next';

import { CategoriesTable } from './components/CategoriesTable';
import { IntegrationForm } from './components/IntegrationForm';
import { ProductsTable } from './components/ProductsTable';

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card';
import { useGetSeo } from '@/hooks/useGetSeo';

export function SeoContent() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.SeoContent',
  });

  const { seo } = useGetSeo();

  return (
    <div className="py-8">
      <section className="mb-10">
        <h1 className="text-[42px] tracking-[8.25px]">{t('title')}</h1>
      </section>

      {seo && (
        <div className="space-y-12">
          <Card>
            <CardHeader>
              <CardTitle>{t('cardTitle')}</CardTitle>
              <CardDescription>{t('cardDescription')}</CardDescription>
            </CardHeader>

            <CardContent>
              <IntegrationForm />
            </CardContent>
          </Card>

          <div className="space-y-8">
            <CategoriesTable />
            <ProductsTable />
          </div>
        </div>
      )}
    </div>
  );
}
